/* eslint-disable max-len */
import React, { SVGProps } from 'react';
import { CustomIconComponentProps } from '@ant-design/icons/es/components/Icon';

export const BetaTagIconSvg = (props: CustomIconComponentProps | SVGProps<SVGSVGElement>) => (
    <svg {...props} viewBox="0 0 36 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="36" height="16" rx="4" fill="url(#paint0_linear_6351_84814)" />
        <path
            d="M29.6313 11.8848L29.062 10.0156H26.1992L25.6299 11.8848H23.8359L26.6074 4H28.6431L31.4253 11.8848H29.6313ZM28.6646 8.61914L28.0952 6.79297C28.0594 6.67122 28.0111 6.51546 27.9502 6.32568C27.8929 6.13232 27.8338 5.93717 27.7729 5.74023C27.7157 5.53971 27.6691 5.36605 27.6333 5.21924C27.5975 5.36605 27.5474 5.54867 27.4829 5.76709C27.422 5.98193 27.363 6.18604 27.3057 6.37939C27.2484 6.57275 27.2072 6.71061 27.1821 6.79297L26.6182 8.61914H28.6646Z"
            fill="white"
        />
        <path
            d="M21.9849 11.8848H20.3198V5.41797H18.1875V4.03223H24.1172V5.41797H21.9849V11.8848Z"
            fill="white"
        />
        <path
            d="M17.1162 11.8848H12.5938V4.03223H17.1162V5.39648H14.2588V7.12061H16.9175V8.48486H14.2588V10.5098H17.1162V11.8848Z"
            fill="white"
        />
        <path
            d="M5 4.03223H7.44385C8.48942 4.03223 9.28076 4.17904 9.81787 4.47266C10.355 4.76628 10.6235 5.2819 10.6235 6.01953C10.6235 6.31673 10.5752 6.58529 10.4785 6.8252C10.3854 7.0651 10.2493 7.26204 10.0703 7.41602C9.89128 7.56999 9.67285 7.67025 9.41504 7.7168V7.77051C9.67643 7.82422 9.91276 7.91732 10.124 8.0498C10.3353 8.17871 10.5036 8.36849 10.6289 8.61914C10.7578 8.86621 10.8223 9.19564 10.8223 9.60742C10.8223 10.0837 10.7059 10.4919 10.4731 10.832C10.2404 11.1722 9.90739 11.4336 9.47412 11.6162C9.04443 11.7952 8.53239 11.8848 7.93799 11.8848H5V4.03223ZM6.66504 7.14209H7.63184C8.11523 7.14209 8.45003 7.06689 8.63623 6.9165C8.82243 6.76253 8.91553 6.53695 8.91553 6.23975C8.91553 5.93896 8.80452 5.72412 8.58252 5.59521C8.36409 5.46273 8.01676 5.39648 7.54053 5.39648H6.66504V7.14209ZM6.66504 8.46338V10.5098H7.75C8.2513 10.5098 8.60042 10.4131 8.79736 10.2197C8.9943 10.0264 9.09277 9.76676 9.09277 9.44092C9.09277 9.24756 9.0498 9.07747 8.96387 8.93066C8.87793 8.78385 8.73291 8.66927 8.52881 8.58691C8.32829 8.50456 8.05078 8.46338 7.69629 8.46338H6.66504Z"
            fill="white"
        />
        <defs>
            <linearGradient
                id="paint0_linear_6351_84814"
                x1="-2.68221e-07"
                y1="8"
                x2="36"
                y2="8"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#3E6FE5" />
                <stop offset="1" stopColor="#8241E7" />
            </linearGradient>
        </defs>
    </svg>
);
